import React from 'react';
import Spinner from '@/components/UI/Spinner';
import { HeartIcon } from '@heroicons/react/24/outline';
import { isMobile } from 'react-device-detect';

const FavouriteGameTag = ({
  isFavourited,
  loading,
}: {
  isFavourited: boolean;
  loading?: boolean;
}) => {
  const mobileSpinner = <Spinner width={18} height={18} />;
  const desktopSpinner = <Spinner width={29} height={29} />;

  if (loading) {
    return isMobile ? mobileSpinner : desktopSpinner;
  }

  if (isFavourited) {
    return (
      <HeartIcon className="fill-blue-light text-transparent hover:fill-white w-[20px] h-[20px] md:h-[32px] md:w-[32px]" />
    );
  }

  return (
    <HeartIcon className="hover:text-blue-light text-white w-[20px] h-[20px] md:h-[32px] md:w-[32px]" />
  );
};

export default FavouriteGameTag;
